import { mutatorAction } from 'satcheljs';
import getListViewState from '../selectors/getListViewState';
import type CopilotResultsStatus from '../store/schema/CopilotResultsStatus';

export const setCopilotResultsTableViewIdsMutator: (
    copilotResultsTableViewId: string | undefined, // This is passed in as undefined if the user is just switching between the Focused/Other tab and the copilot results tab is already open (and therefore has been set)
    copilotResultsOriginTableViewId: string
) => void = mutatorAction(
    'setCopilotResultsTableViewIdsMutator',
    function setCopilotResultsTableViewIdsMutator(
        copilotResultsTableViewId: string | undefined,
        copilotResultsOriginTableViewId: string
    ): void {
        const state = getListViewState();
        if (copilotResultsTableViewId) {
            state.copilotResultsTableViewId = copilotResultsTableViewId;
        }
        state.copilotResultsOriginTableViewId = copilotResultsOriginTableViewId;
    }
);

export const setCopilotResultsStatusMutator: (status: CopilotResultsStatus) => void = mutatorAction(
    'setCopilotResultsStatusMutator',
    function setCopilotResultsStatusMutator(status: CopilotResultsStatus): void {
        getListViewState().copilotResultsStatus = status;
    }
);

export const dismissCopilotResultsTabMutator: () => void = mutatorAction(
    'dismissCopilotResultsTabMutator',
    function dismissCopilotResultsTabMutator(): void {
        const state = getListViewState();
        state.copilotResultsTableViewId = undefined;
        state.copilotResultsOriginTableViewId = undefined;
        state.copilotResultsStatus = 0;
    }
);
